import { render, staticRenderFns } from "./NegociacaoAlterarRespostaProdutoRow.vue?vue&type=template&id=af73d922&scoped=true&"
import script from "./NegociacaoAlterarRespostaProdutoRow.vue?vue&type=script&lang=js&"
export * from "./NegociacaoAlterarRespostaProdutoRow.vue?vue&type=script&lang=js&"
import style0 from "./NegociacaoAlterarRespostaProdutoRow.vue?vue&type=style&index=0&id=af73d922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af73d922",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
